<template>
  <div :class="['modal', { 'is-active': show }]">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
        <button class="delete" @click="$emit('hide')"></button>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent="onSubmit">
          <div class="field">
            <label class="label">Name</label>
            <div class="control">
              <input
                class="input"
                name="name"
                type="text"
                v-model="symptom.name"
                autofocus
              />
            </div>
          </div>

          <div class="field is-grouped is-pulled-right">
            <div class="control">
              <button
                :class="['button', 'is-primary', { 'is-loading': loading }]"
              >
                {{ label }}
              </button>
            </div>
            <div class="control">
              <a class="button" @click="$emit('hide')">Cancel</a>
            </div>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "symptom-form",

  props: ["show", "title", "symptom", "label", "loading", "onSubmit"]
};
</script>

<style lang="scss" scoped></style>
